module.exports = __webpack_public_path__ + "static/media/TermsAndConditions.0bad7213.md";